import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { AuthCoreService } from '../../core/auth-core/auth-core.service';


export const authGuard = () => {
  //   const authService = inject(AuthService);
  const router = inject(Router);
  if (AuthCoreService.isLoggedIn) {
    return true;
  } else {
    return router.navigateByUrl('/auth/login');
  }
};
